<template>
  <cms-parallax
    v-if="parallaxContent"
    :config="parallaxSetUp"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewParallax' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const homepage = computed(() => store.state.homepage);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => (isThemePreview.value ? 'preview_id' : `${props.containerId}_${props.componentIdx}`));

const parallaxSetUp = computed(() => homepage.value.parallax[id.value]);

const parallaxContent = computed(() => !isEmpty(homepage.value?.parallax?.[id.value]?.background_image));
</script>
